import { Button } from 'antd'
import { QureosWhiteLogo } from '@qureos/assets'
import { BOOK_A_DEMO, HIRE_NOW } from '@qureos/statics/job-application'

interface HireHeaderProps {
  createInstantJob: any
}

export const HireHeader: React.FC<HireHeaderProps> = ({ createInstantJob }) => {
  const bookDemoUrl =
    'https://calendly.com/alex-qureos/iris-demo-20-min?utm_source=platform&utm_medium=demo&utm_campaign=platform-lead-generation'

  return (
    <header className="bg-black items-center flex justify-between sticky top-0 shadow-lg w-full z-50 px-4 py-2 md:px-8 md:py-4">
      <div className="flex items-center space-x-4">
        <img className="inline-block w-24" src={QureosWhiteLogo} alt="Qureos" />
      </div>
      <div>
        <Button
          onClick={() => createInstantJob()}
          type="text"
          className="text-white sm:inline-block hidden">
          {HIRE_NOW}
        </Button>
        <Button
          type="text"
          onClick={() => window.open(bookDemoUrl, '_blank')}
          className="bg-qureosPrimary px-2 py-0 rounded-md text-white">
          {BOOK_A_DEMO}
        </Button>
      </div>
    </header>
  )
}
